import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';


// ----------------------------------------------------------------------

export default function App(props) {
    const themeMode=useSelector(state=>state.dom.config.themeMode);
    const history = useNavigate();

    useEffect(() => {
        // Dynamically load the TinyMCE script if not included in index.html
        const script = document.createElement('script');
        script.src = '/tinymce/tinymce.min.js'; // Ensure this path matches the self-hosted location
        script.onload = () => {
            console.log('TinyMCE loaded successfully');
        };
        script.onerror = () => console.error('Error loading TinyMCE');
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    useEffect(()=>{
        if(process.env.REACT_APP_COMING_SOON==="true"){
            history('/coming-soon');
        }
    },[history])
    return (
        <ThemeProvider themeMode={themeMode}>
            <ScrollToTop/>
            <Router />
        </ThemeProvider>
    );
}
